import Swal from 'sweetalert2';
import 'animate.css';

/** Muestra modal de carga con spinner */
let isLoadingSwalOpen = false;
let swal_showClass = { popup: 'animate__animated animate__fadeIn animate__faster' };
let swal_hideClass = { popup: 'animate__animated animate__fadeOut animate__faster'};


export const swal_loading = (titulo?: string, texto?: string) => {
  const { $i18n } = useNuxtApp();
  Swal.fire({
    //title: titulo ?? $i18n.t('common.message.loading'),
    //text: texto ?? $i18n.t('common.message.please_wait'),
    title: '',
    text: '',
    background: 'transparent',
    backdrop: 'rgba(255, 255, 255, 0.66)',
    showClass: swal_showClass,
    hideClass: swal_hideClass,
    allowOutsideClick: false,
    allowEscapeKey: false,
    showConfirmButton: false,
    html: `
      <div style="display:flex;justify-content:center;margin-top:20px;">
        <img 
          src="/images/iqa-loading.gif" 
          alt="loading"
          style="width:120px;height:120px;
          filter: drop-shadow(0 4px 10px rgba(0, 0, 0, 0.11));"
        />
      </div>
    `,

    /* didOpen: () => {
      Swal.showLoading();
    }, */
  }); 
};
export const swal_loading_2 = (titulo?: string, texto?: string) => {
  const { $i18n } = useNuxtApp();
  Swal.fire({
    title: titulo ?? $i18n.t('common.message.loading'),
    text: texto ?? $i18n.t('common.message.please_wait'),
    background: 'transparent',
    backdrop: 'rgba(255, 255, 255, 0.66)',
    showClass: swal_showClass,
    hideClass: swal_hideClass,
    allowOutsideClick: false,
    showConfirmButton: false,
    didOpen: () => {
      Swal.showLoading();
    },
  }); 
};
export const swal_close = () => { 
  Swal.close();
};

/** Muestra mensaje de éxito */
//se usa async para evitar que, en el caso de que haya un redirect después del sweet alert,
//el usuario tenga que dar click en ok en el sweet alert, para que sólo luego de eso, el redirect se pueda efectuar.

export const swal_success = async ( texto?: string, titulo?: string, botonDeConfirmacion : string | null = null ) => {
    const { $i18n } = useNuxtApp();
    Swal.hideLoading(); // remueve spinner si usaste showLoading()
    isLoadingSwalOpen = false;
    await Swal.fire({
      icon: 'success',
      title: titulo ??  $i18n.t('common.message.success'),
      html: texto ?? $i18n.t('common.message.success_subtitle'),
      showClass: swal_showClass,
      hideClass: swal_hideClass,
      confirmButtonColor: '#0d9488',
      confirmButtonText: botonDeConfirmacion || $i18n.t('common.action.continue')
    });
};

/** Muestra error genérico (oops) */
export const swal_oops = async ( texto?: string, titulo?: string ) => {
    const { $i18n } = useNuxtApp()
    Swal.hideLoading(); // remueve spinner si usaste showLoading()
    isLoadingSwalOpen = false;
    await Swal.fire({
      icon: 'error',
      title: titulo ??  $i18n.t('common.message.oops'),
      html: texto ?? $i18n.t('common.message.unexpected_error'),
      showClass: swal_showClass,
      hideClass: swal_hideClass,
      confirmButtonColor: '#0d9488',
      confirmButtonText: $i18n.t('common.action.close'),
  });
};

export const swal_confirm_continue = async (
  callback: () => void, titulo: string, texto: string, 
  botonDeConfirmacion : string | null = null, botonDeCancelar : string | null = null
) => {
    const { $i18n } = useNuxtApp()
    Swal.hideLoading(); // remueve spinner si usaste showLoading()
    isLoadingSwalOpen = false;
    const result = await Swal.fire({
      title: titulo ??  $i18n.t('common.message.ask_action_title'),
      html: texto ?? $i18n.t('common.message.ask_action_subtitle'),
      showClass: swal_showClass,
      hideClass: swal_hideClass,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#0d9488',
      confirmButtonText: botonDeConfirmacion || $i18n.t('common.sweet_alert.confirmButtonText'),
      cancelButtonText: botonDeCancelar || $i18n.t('common.action.cancel'),
    });

    /* if (result.isConfirmed) {
        callback();
    } */
    return result.isConfirmed;
};
export const swal_add_detail = async ( callback: () => void, titulo?: string, texto?: string ) => {
    const { $i18n } = useNuxtApp()
    Swal.hideLoading(); // remueve spinner si usaste showLoading()
    isLoadingSwalOpen = false;
    const result = await Swal.fire({
      title: titulo ?? $i18n.t('common.message.ask_adding_observation'), 
      input: 'text',
      showClass: swal_showClass,
      hideClass: swal_hideClass,
      inputPlaceholder: texto ?? $i18n.t('common.message.observation_title') + "...", 
      showCancelButton: true,
      confirmButtonColor: '#0d9488',
      confirmButtonText: $i18n.t('common.action.continue'),
      cancelButtonText: $i18n.t('common.action.omit'),
    }).then((result) => {
      if (result.isConfirmed) {
        const userInput = result.value
        return userInput;
        // send it as a parameter here (e.g., API call, store update, etc.)
      }
    })
    return result;

    /* if (result.isConfirmed) {
        callback();
    } */
};